import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'
import { DetailPageActions, DetailPageActionTypes } from '../actions'
import { Reducer } from 'redux'

export type WatchlistDetail = WpsTypes.atv.wps.WatchlistActionProps & { failed?: boolean | null }

export type TitleIdToWatchlist = {
  [titleId: string]: WatchlistDetail | undefined
}

const initialState = {} as TitleIdToWatchlist

const watchlistReducer: Reducer<TitleIdToWatchlist, DetailPageActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.WatchlistToggle:
      return action.output.watchlist[action.payload.pageTitleId] && {
          ...state,
          [action.payload.pageTitleId]: { ...action.output.watchlist[action.payload.pageTitleId]!, failed: false }
        }
        || state
    case DetailPageActionTypes.WatchlistToggleFailed:
      return state[action.payload.pageTitleId] && {
        ...state,
        [action.payload.pageTitleId]: { ...state[action.payload.pageTitleId]!, failed: true }
      } || state
    case DetailPageActionTypes.ClearWatchlistToggleFailure:
      return state[action.payload.pageTitleId] && {
        ...state,
        [action.payload.pageTitleId]: { ...state[action.payload.pageTitleId]!, failed: null }
      } || state
    default:
      return state
  }
}

export const reducer = createMergeReducer(t => t.watchlist, initialState, watchlistReducer)
